import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "store";

const initialState = {
	isSetupDialogActive: false,
	shouldOpenTenantDrawerOnEnterPortal: false,
};

const setupDialogSlice = createSlice({
	name: "setupDialog",
	initialState: initialState,
	reducers: {
		setSetupDialogActive: (state, { payload }) => {
			state.isSetupDialogActive = payload;
		},
		setShouldOpenTenantDrawerOnEnterPortal: (state, { payload }) => {
			state.shouldOpenTenantDrawerOnEnterPortal = payload;
		},
	},
});

export const selectIsSetupDialogActive = (state: RootState) =>
	state.setupDialog.isSetupDialogActive;
export const selectShouldOpenTenantDrawerOnEnterPortal = (state: RootState) =>
	state.setupDialog.shouldOpenTenantDrawerOnEnterPortal;

export const { setSetupDialogActive, setShouldOpenTenantDrawerOnEnterPortal } =
	setupDialogSlice.actions;

export default setupDialogSlice.reducer;
